@let mode = ccrMode();
@let currentCCR = ccr();
@let campaign = identifyCampaign(currentCCR);
@let commercial = identifyCommercial(currentCCR);
<div class="row">
  <div class="col-12">
    <sb-card>
      <div card-header>
        @if (mode === 'commercial') {
          <h3>{{ 'lang.globals.commercial' | translate }}</h3>
        }
        @if (mode === 'campaign') {
          <h3>{{ currentCCR?.customer?.name }}</h3>
          <small>
            <sb-icon class="mr-1" icon="user"></sb-icon>
            {{ 'lang.globals.customer' | translate }}</small>
        }
      </div>
      @if (mode === 'commercial') {
        <div card-header-more
             *ngIf="!util.getPageLink().includes('requirement-create')">
          <a *ngPermissions="permissionService.Permission.campaign_edit"
             [queryParams]="{returnTo: util.getPageLink()}" [sbRouterLink]="util.RoutingID.requirementCreate"
             [pathParams]="[{id: 'campaignID', value: campaignId},{id: 'commercialID', value:commercialId}]">
            <button class="btn btn-success">
              <sb-icon class="mr-1" icon="plus"></sb-icon>
              {{ 'lang.globals.addRequirement' | translate }}
            </button>
          </a>
        </div>
      }
      <div card-fit>
        <table class="table">
          <tbody>
          <tr>
            @if (mode === 'campaign') {
              <td>
                <sb-icon icon="level"></sb-icon>
                {{ campaign?.level?.id?.level }}
              </td>
            }
            <td style="width: 418px;">
              <div class="d-flex align-items-center">
                <sb-preview-tooltip class="mr-3" [previews]="currentCCR?.preview" [still]="true"></sb-preview-tooltip>
                @if (mode === 'campaign') {
                  <sb-comp-name-wrapper>
                    <div firstLine>
                      <sb-icon [dualColor]="true" class="mr-2 headline" [icon]="ccrIcon()"></sb-icon>
                      <sb-comp-link
                        [title]="campaign?.name | truncate: 25"
                        [classes]="'headline'"
                        [permission]="permissionService.Permission.campaign_edit" class="cursor-pointer"
                        [link]="util.RoutingID.campaignEdit"
                        [pathParams]="[{id: 'campaignID', value:  campaignId}]"
                        [tooltip]="'lang.globals.editCampaign' | translate">
                      </sb-comp-link>
                    </div>
                    <div secondLine>
                      <small>{{ 'lang.globals.campaign' | translate }} {{ 'lang.ccrHero.with' | translate }}
                        <a class="link font-weight-bold" [sbRouterLink]="util.RoutingID.commercials"
                           [pathParams]="[{id: 'campaignID', value:  campaignId}]"
                        >
                          <sb-comp-commercial-count [commercialCount]="campaign?.commercialCount"></sb-comp-commercial-count>
                        </a>
                      </small>
                    </div>
                    <div thirdLine>
                      <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [resolveInComponent]="true"
                               [dtoType]="tagService.TaggableDTO.Campaign" [dtoId]="campaignId">
                      </sb-tags>
                    </div>
                  </sb-comp-name-wrapper>
                }
                @if (mode === 'commercial') {
                  <!-- Commercial area -->
                  <sb-comp-name-wrapper>
                    <div firstLine>
                      <sb-icon class="mr-2 headline" [dualColor]="true" [icon]="ccrIcon()"></sb-icon>
                      <sb-comp-link
                        [title]="commercial?.name | truncate : 25"
                        [classes]="'headline'"
                        [permission]="permissionService.Permission.campaign_edit" class="cursor-pointer"
                        [link]="util.RoutingID.commercialsEdit"
                        [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercialId}]"
                        [tooltip]="'lang.globals.editCommercial' | translate">
                      </sb-comp-link>
                    </div>
                    <div secondLine>
                      <small *ngIf="commercial?.requirementCount > 1">{{ 'lang.globals.commercial' | translate }}
                        <a class="link font-weight-bold" [sbRouterLink]="util.RoutingID.requirements"
                           [pathParams]="[{id: 'campaignID', value: campaignId}, {id: 'commercialID', value: commercialId}]"
                        >
                          {{ 'lang.ccrHero.with' | translate }} {{ commercial?.requirementCount + ' ' + ('lang.requirementsList.requirements' | translate) }}
                        </a>
                      </small>
                    </div>
                    <div thirdLine>
                      <sb-tags *ngPermissions="[permissionService.Permission.tag_list]" [resolveInComponent]="true"
                               [dtoType]="tagService.TaggableDTO.Commercial" [dtoId]="commercialId">
                      </sb-tags>
                    </div>
                  </sb-comp-name-wrapper>
                }
              </div>
            </td>
            @if (mode === 'campaign' && campaign.budget) {
              <td>
                <p class="font-weight-bold m-0">
                  <sb-icon ngbTooltip="Budget" container="body" class="mr-1" icon="budgetCoin"></sb-icon>
                  <span>{{ (campaign?.budget.amount  | sbNumberFormat) + ' ' + campaign.budget.currency.symbol }}
                    / {{ (campaign?.budget.amount | sbNumberFormat) + ' ' + campaign.budget.currency.symbol }}</span>
                </p>
              </td>
            }
            <td style=" width: 118px;">
              <sb-verification-progress [bookingStatus]="currentCCR?.bookingStatus"></sb-verification-progress>
            </td>
            <td>
              @switch (currentCCR?.timingStatus) {
                @case ('Future') {
                  <span class="badge blue">{{ 'lang.globals.planned' | translate }}</span>
                }
                @case ('Present') {
                  <span class="badge green">{{ 'lang.globals.running' | translate }}</span>
                }
                @case ('Past') {
                  <span class="badge grey">{{ 'lang.globals.expired' | translate }}</span>
                }
                @case ('Unknown') {
                  <span class="badge grey">{{ 'lang.globals.noTiming' | translate }}</span>
                }
              }
            </td>
            <td>
              <sb-comp-progressbar-wrapper *ngIf="currentCCR" [campaignOrCommercial]="currentCCR"></sb-comp-progressbar-wrapper>
            </td>

            <td>
              <sb-comp-playout-aggregation [playoutAggregation]="currentCCR?.playoutAggregation"></sb-comp-playout-aggregation>
            </td>
            <td class="d-xxl-table-cell d-none" style="width: 180px;" *ngPermissions="permissionService.Permission.ds_cm_reporting">
              <sb-line-small-chart
                [chartData]="currentCCR?.reporting"></sb-line-small-chart>
            </td>
            <td>
              <sb-comp-filter-overview hideClass="d-xxl" [timeCull]="currentCCR?.timeCull" [geoCull]="currentCCR?.geoCull"
                                       [stateSpaceCull]="currentCCR?.stateSpaceCull" [playerCull]="currentCCR?.playerCull">
              </sb-comp-filter-overview>
            </td>
            <td class="d-xl-table-cell d-none">
              <div class="filter">
                <div class="filter__sum">
                  <div class="filter__sum__item">
                    <sb-icon icon="location"></sb-icon>
                    {{ currentCCR?.playerAggregation?.locations | sbNumberFormat }}
                  </div>
                  /
                  <div class="filter__sum__item">
                    <sb-icon icon="screen"></sb-icon>
                    {{ currentCCR?.playerAggregation?.screens | sbNumberFormat }}
                  </div>
                </div>
              </div>
            </td>
            <td>
              <sb-comp-display-created [data]="currentCCR"></sb-comp-display-created>
            </td>
            <td class="text-end">
              <ng-container *ngPermissions="permissionService.Permission.campaign_edit">
                <a *ngIf="mode === 'campaign'" [queryParams]="{returnTo: util.getPageLink()}"
                   [sbRouterLink]="util.RoutingID.campaignEdit" [pathParams]="[{id: 'campaignID',value: campaignId}]">
                  <button class="btn btn-secondary" placement="top" container="body"
                          ngbTooltip="{{'lang.globals.editCampaign' | translate}}">
                    <sb-icon icon="edit"></sb-icon>
                  </button>
                </a>
                <a *ngIf="mode === 'commercial'" [queryParams]="{returnTo: util.getPageLink()}"
                   [sbRouterLink]="util.RoutingID.commercialsEdit"
                   [pathParams]="[{id: 'campaignID', value: campaignId},{id: 'commercialID', value: commercialId}]">
                  <button class="btn btn-secondary" placement="top" container="body"
                          ngbTooltip="{{'lang.globals.editCommercial' | translate}}">
                    <sb-icon icon="edit"></sb-icon>
                  </button>
                </a>
              </ng-container>
              <button *ngPermissions="permissionService.Permission.ds_cm_reporting"
                      container="body"
                      ngbTooltip="{{'lang.globals.toggleCollapse' | translate}}" placement="top" type="button"
                      class="btn btn-hover-primary ml-2" (click)="displayData();" [attr.aria-expanded]="!isCollapsed()"
                      aria-controls="collapseExample">
                @if (isCollapsed()) {

                  <sb-icon icon="chevronDown"></sb-icon>
                } @else {
                  <sb-icon icon="chevronUp"></sb-icon>
                }

              </button>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="card-body" *ngPermissions="permissionService.Permission.ds_cm_reporting"
             [@smoothCollapse]="isCollapsed() ?'initial':'final'">
          <ng-container>
            <div class="tw-flex tw-justify-between">
              <h5>{{ 'lang.ccrHero.playouts30Days' | translate }}</h5>
              <div>
                <sb-comp-chart-control [showPlayerCull]="false" [enableHourInterval]="true" (dateChange)="dateChanged($event)" [from]="from"
                                       [till]="till"
                                       [(interval)]="interval" (intervalChange)="refreshFromServer()"></sb-comp-chart-control>
              </div>
            </div>
            @if (!loading()) {

              <div class="pt-4">
                <div
                  *ngIf="(currentCCR.timingStatus==='Future' || currentCCR.timingStatus==='Unknown')">{{ 'lang.ccrHero.StatisticAppearDataAvailable' | translate }}
                </div>
                <div
                  *ngIf="currentCCR.timingStatus==='Past'">{{ 'lang.ccrHero.reportingAvailableSoon' | translate }}
                </div>
              </div>
              <sb-chart chartType="lineChart" *ngIf="lineChartGradient.loadingDone"
                        [chartData]="lineChartGradient"></sb-chart>
            } @else {
              <sb-loading-spinner></sb-loading-spinner>
            }
          </ng-container>
        </div>
      </div>
    </sb-card>
  </div>
</div>
